export const surveySummarySelector = state => state.surveySummary;
